t = require('app/scripts/views/internal/teacup-with-helpers')('popover_member_searcher')

module.exports = ->
  t.mustacheBlock 'showSearch', ->
    t.input '.js-filter-members.js-autofocus', { type: 'text', placeholder: t.l('search-members-ellipsis') }

  t.ul '.pop-over-member-list.checkable.js-members-list'
